import { Component, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalDirective, ModalModule } from 'ngx-bootstrap/modal';
import { ApiTournamentsService } from '../../../../services/tournaments/api/api-tournaments.service';
import { AlertsService } from '../../../../services/alerts.service';
import { Tournament } from '../../../../models/tournaments/tournament.model';
import { TournamentReward } from '../../../../models/tournaments/tournament-reward.model';
import { TournamentType } from '../../../../enums/tournaments/tournament-type.enum';

@Component({
  selector: 'app-tournament-edit-modal',
  templateUrl: './tournament-edit-modal.component.html',
  standalone: true,
  imports: [ModalModule, CommonModule, FormsModule]
})
export class TournamentEditModalComponent {

  @ViewChild('modal') modal!: ModalDirective;

  isLoading: boolean = false;
  tournamentId: number = 0;
  type: number = 0;
  startDate: string = '';
  endDate: string = '';
  costQuantity: number = 0;
  rewardTotalQuantity: number = 0;
  usersCount: number = 0;
  rewards: TournamentReward[] = [];

  readonly tournamentTypes = Object.entries(TournamentType).filter(([, v]) => typeof v === 'number') as [string, number][];

  private callbackSaved?: () => void;

  constructor(private apiTournamentsService: ApiTournamentsService, private alertsService: AlertsService) {}

  show(tournament: Tournament, callbackSaved?: () => void): void {
    this.callbackSaved = callbackSaved;
    this.tournamentId = tournament.tournamentId;
    this.type = tournament.type;
    this.startDate = tournament.startDateTimestamp ? this.timestampToDateString(tournament.startDateTimestamp) : '';
    this.endDate = tournament.endDateTimestamp ? this.timestampToDateString(tournament.endDateTimestamp) : '';
    this.costQuantity = tournament.costQuantity;
    this.rewardTotalQuantity = tournament.rewardTotalQuantity;
    this.usersCount = tournament.usersCount;
    this.rewards = tournament.rewards.map(r => { const rw = new TournamentReward(); rw.rangeMin = r.rangeMin; rw.rangeMax = r.rangeMax; rw.rewardQuantity = r.rewardQuantity; return rw; });
    this.isLoading = false;
    this.modal.show();
  }

  addReward(): void { this.rewards.push(new TournamentReward()); }
  removeReward(i: number): void { this.rewards.splice(i, 1); }

  save(): void {
    this.isLoading = true;
    const startTimestamp = this.startDate ? Math.floor(new Date(this.startDate + 'Z').getTime() / 1000) : 0;
    const endTimestamp = this.endDate ? Math.floor(new Date(this.endDate + 'Z').getTime() / 1000) : 0;
    this.apiTournamentsService.editTournament(this.tournamentId, this.type, startTimestamp, endTimestamp, this.costQuantity, this.rewardTotalQuantity, this.rewards).then(
      () => {
        this.isLoading = false;
        this.modal.hide();
        this.alertsService.displayAlertSuccess('Tournament updated !');
        if (this.callbackSaved) { this.callbackSaved(); }
      }, error => {
        this.isLoading = false;
        this.alertsService.displayAlertError('Error updating tournament : ' + error);
      }
    );
  }

  private timestampToDateString(timestamp: number): string {
    const d = new Date(timestamp * 1000);
    const month = (d.getUTCMonth() + 1).toString().padStart(2, '0');
    const day = d.getUTCDate().toString().padStart(2, '0');
    const hours = d.getUTCHours().toString().padStart(2, '0');
    const minutes = d.getUTCMinutes().toString().padStart(2, '0');
    return `${d.getUTCFullYear()}-${month}-${day}T${hours}:${minutes}`;
  }
}
